module.exports = __webpack_public_path__ + "static/media/star.45dd5470.png";